enum LOCATIONS_ACTION_TYPES {
	GET_LOCATIONS_LIST = 'GET_LOCATIONS_LIST',
	GET_LOCATIONS_LIST_SUCCESS = 'GET_LOCATIONS_LIST_SUCCESS',
	GET_LOCATIONS_LIST_ERROR = 'GET_LOCATIONS_LIST_ERROR',
	CLEAR_LOCATIONS_LIST = 'CLEAR_LOCATIONS_LIST',
}

export default LOCATIONS_ACTION_TYPES;
